import { jsx as _jsx } from "react/jsx-runtime";
// import utils
import { forwardRef } from "react";
// import components
import ButtonBase from "@mui/material/ButtonBase";
export const ButtonBaseAtomComponent = forwardRef(function ButtonBaseAtom(props, ref) {
    return _jsx(ButtonBase, { "data-testid": "ButtonBase", ...props, ref: ref });
});
export default ButtonBaseAtomComponent;
